import { render, staticRenderFns } from "./ScrollAnimate.vue?vue&type=template&id=8be2715e&scoped=true&"
import script from "./ScrollAnimate.vue?vue&type=script&lang=js&"
export * from "./ScrollAnimate.vue?vue&type=script&lang=js&"
import style0 from "./ScrollAnimate.vue?vue&type=style&index=0&id=8be2715e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8be2715e",
  null
  
)

export default component.exports